// How the page now showing was arrived at, for search analytics: freshly
// ("navigate": a link, a typed address, a click within the app) or shown again
// ("reload": the browser's Reload, Back or Forward). The search pages put their
// search in the address bar, so without this a refresh or Back would look like
// opening a shared link.

function initialNavigationType () {
  const entries = window.performance && window.performance.getEntriesByType
    ? window.performance.getEntriesByType('navigation')
    : []
  return entries.length ? entries[0].type : 'navigate'
}

export function createPageArrivals (readInitialType = initialNavigationType) {
  let arrival = 'navigate'
  let firstNavigation = true
  let historyNavigation = false

  return {
    // Call once, with the app's router.
    track (router) {
      // Back and Forward within the app arrive as popstate, before the router
      // finishes the navigation they start.
      window.addEventListener('popstate', () => { historyNavigation = true })
      router.afterEach(() => {
        if (firstNavigation) {
          // The page the browser loaded: ask the browser how it was loaded.
          const type = readInitialType()
          arrival = type === 'reload' || type === 'back_forward' ? 'reload' : 'navigate'
          firstNavigation = false
        } else {
          arrival = historyNavigation ? 'reload' : 'navigate'
        }
        historyNavigation = false
      })
    },

    // 'navigate' or 'reload', for the page now showing.
    current () {
      return arrival
    }
  }
}

const pageArrivals = createPageArrivals()

export const trackPageArrivals = (router) => pageArrivals.track(router)
export const pageArrival = () => pageArrivals.current()
